document.addEventListener('DOMContentLoaded', function () {
    initProductHeroCustom();
});

function initProductHeroCustom() {
    initProductHeroCustomSwiper();
    initProductHeroCustomVariants();
    initProductHeroCustomAccordions();
    initProductHeroCustomQuantity();
    initProductHeroCustomMimicSelector();
    initProductHeroCustomCartLimits();
}

function initProductHeroCustomSwiper() {
    if (typeof Swiper === 'undefined') {
        console.warn('Swiper library not loaded. Product hero gallery will not initialize.');
        return;
    }

    const sections = document.querySelectorAll('.productHeroCustom');

    sections.forEach((section) => {
        const mainEl = section.querySelector('.productHeroCustom_galleryMain');
        const thumbsEl = section.querySelector('.productHeroCustom_galleryThumbs');

        if (!mainEl || !thumbsEl) return;

        const thumbsSwiper = new Swiper(thumbsEl, {
            slidesPerView: "auto",
            spaceBetween: 10,
            watchSlidesProgress: true,
        });

        const mainSwiper = new Swiper(mainEl, {
            slidesPerView: 1,
            spaceBetween: 16,
            thumbs: {
                swiper: thumbsSwiper,
            },
        });

        mainSwiper.on('slideChange', () => {
            if (!thumbsSwiper.destroyed) {
                thumbsSwiper.slideTo(mainSwiper.realIndex);
            }
        });
    });
}

function initProductHeroCustomVariants() {
    const sections = document.querySelectorAll('.productHeroCustom');

    sections.forEach((section) => {
        const variantsJson = section.querySelector('[data-variants]');
        const priceEl = section.querySelector('[data-price]');
        const priceWrapper = section.querySelector('.productHeroCustom_price');
        const compareEl = section.querySelector('[data-compare-price]');
        const atcButton = section.querySelector('[data-atc-button]');
        const variantIdInput = section.querySelector('[data-variant-id-input]');
        const optionGroups = section.querySelectorAll('[data-option-index]');

        if (!variantsJson || !variantIdInput) return;

        const variants = JSON.parse(variantsJson.textContent);

        const getSelectedOptions = () => {
            const selected = [];
            optionGroups.forEach((group) => {
                const checked = group.querySelector('input[type="radio"]:checked');
                selected.push(checked ? checked.value : null);
            });
            return selected;
        };

        const findVariantByOptions = (options) => {
            return variants.find((variant) => {
                return variant.options.every((option, index) => option === options[index]);
            });
        };

        const updateSelectedOptionStyles = () => {
            optionGroups.forEach((group) => {
                const options = group.querySelectorAll('.productHeroCustom_variantOption');
                options.forEach((option) => option.classList.remove('selected-variant'));

                const checked = group.querySelector('input[type="radio"]:checked');
                if (checked) {
                    const label = checked.closest('.productHeroCustom_variantOption');
                    if (label) label.classList.add('selected-variant');
                }
            });
        };

        const updateVariant = (variantId) => {
            const variant = variants.find((v) => v.id === Number(variantId));
            if (!variant) return;

            variantIdInput.value = variant.id;

            if (priceEl) {
                priceEl.textContent = formatMoney(variant.price);
            }

            if (compareEl) {
                if (variant.compare_at_price && variant.compare_at_price > variant.price) {
                    compareEl.textContent = formatMoney(variant.compare_at_price);
                    compareEl.style.display = '';
                    priceWrapper.classList.add('has-compare-price');
                } else {
                    compareEl.style.display = 'none';
                    priceWrapper.classList.remove('has-compare-price');
                }
            }

            if (atcButton) {
                const atcLabel = atcButton.querySelector('span');
                const productQuantity = section.querySelector('.productHeroCustom_quantity');
                if (!variant.available) {
                    if (atcLabel) atcLabel.textContent = 'Sold Out';
                    atcButton.classList.add('atc-disabled');
                    productQuantity?.classList.add('atc-disabled');
                    atcButton.setAttribute('disabled', 'disabled');
                    atcButton.setAttribute('aria-disabled', 'true');
                } else {
                    if (atcLabel) atcLabel.textContent = atcButton.getAttribute('data-available-label') || 'Add to Cart';
                    atcButton.classList.remove('atc-disabled');
                    atcButton.removeAttribute('disabled');
                    atcButton.removeAttribute('aria-disabled');
                    productQuantity?.classList.remove('atc-disabled');
                }
            }

            const url = new URL(window.location.href);
            url.searchParams.set('variant', variant.id);
            window.history.replaceState({}, '', url);

            section.dispatchEvent(
                new CustomEvent('productHeroCustom:variant-change', {
                    detail: { variantId: variant.id },
                })
            );
        };

        const initialVariantId = variantIdInput.value;
        if (initialVariantId) {
            updateVariant(initialVariantId);
            updateSelectedOptionStyles();
        }

        if (optionGroups.length > 0) {
            optionGroups.forEach((group) => {
                group.addEventListener('change', () => {
                    const selectedOptions = getSelectedOptions();
                    const selectedVariant = findVariantByOptions(selectedOptions);
                    if (selectedVariant) {
                        updateVariant(selectedVariant.id);
                    }
                    updateSelectedOptionStyles();
                });
            });
        }
    });
}

function initProductHeroCustomCartLimits() {
    const sections = document.querySelectorAll('.productHeroCustom');

    sections.forEach((section) => {
        const variantsJson = section.querySelector('[data-variants]');
        const variantIdInput = section.querySelector('[data-variant-id-input]');
        const qtyInput = section.querySelector('input[name="quantity"]');
        const decreaseBtn = section.querySelector('[data-qty-decrease]');
        const increaseBtn = section.querySelector('[data-qty-increase]');
        const atcButton = section.querySelector('[data-atc-button]');
        const productForm = section.querySelector('product-form');
        const formEl = productForm?.querySelector('form');

        if (!variantsJson || !variantIdInput || !qtyInput) return;

        const variants = JSON.parse(variantsJson.textContent);
        let cartQuantities = {};

        const setErrorMessage = (message) => {
            if (!productForm) return;
            if (typeof productForm.handleErrorMessage === 'function') {
                productForm.handleErrorMessage(message || false);
                return;
            }
            const wrapper = productForm.querySelector('.product-form__error-message-wrapper');
            const messageEl = wrapper?.querySelector('.product-form__error-message');
            if (!wrapper || !messageEl) return;
            wrapper.toggleAttribute('hidden', !message);
            if (message) messageEl.textContent = message;
        };

        const toggleAtc = (disabled) => {
            if (!atcButton) return;
            if (disabled) {
                atcButton.setAttribute('disabled', 'disabled');
                atcButton.setAttribute('aria-disabled', 'true');
                atcButton.classList.add('atc-disabled');
            } else {
                atcButton.removeAttribute('disabled');
                atcButton.removeAttribute('aria-disabled');
                atcButton.classList.remove('atc-disabled');
            }
        };

        const toggleIncrease = (disabled) => {
            if (!increaseBtn) return;
            if (disabled) {
                increaseBtn.setAttribute('disabled', 'disabled');
            } else {
                increaseBtn.removeAttribute('disabled');
            }
        };

        const buildCartQuantities = (cart) => {
            cartQuantities = {};
            if (!cart?.items) return;
            cart.items.forEach((item) => {
                if (!item.variant_id) return;
                cartQuantities[item.variant_id] = item.quantity;
            });
        };

        const getCurrentVariant = () => {
            const currentId = Number(variantIdInput.value);
            return variants.find((variant) => variant.id === currentId);
        };

        const updateControls = () => {
            const variant = getCurrentVariant();
            if (!variant) return;

            const quantityRule = variant.quantity_rule || {};
            const min = Number.isFinite(quantityRule.min) ? quantityRule.min : 1;
            const step = Number.isFinite(quantityRule.increment) ? quantityRule.increment : 1;
            const max = typeof quantityRule.max === 'number' ? quantityRule.max : null;
            const cartQty = cartQuantities[variant.id] || 0;

            let minValue = min;
            const remainingMax = max === null ? null : max - cartQty;

            if (remainingMax !== null) {
                minValue = Math.min(minValue, remainingMax);
                if (cartQty >= min) minValue = Math.min(minValue, step);
            }

            qtyInput.min = minValue;
            if (remainingMax !== null) {
                qtyInput.max = remainingMax;
            } else {
                qtyInput.removeAttribute('max');
            }
            if (step) qtyInput.step = step;

            const currentQty = parseInt(qtyInput.value, 10) || 0;
            if (remainingMax !== null && currentQty > remainingMax) {
                qtyInput.value = remainingMax;
            }

            const maxReached = remainingMax !== null && remainingMax <= 0;
            if (maxReached) {
                toggleAtc(true);
            } else if (variant.available) {
                toggleAtc(false);
            }
            toggleIncrease(remainingMax !== null && (parseInt(qtyInput.value, 10) || 0) >= remainingMax);

            if (maxReached) {
                setErrorMessage('The maximum quantity of this item is already in your cart.');
            } else {
                setErrorMessage(false);
            }

            if (formEl) {
                formEl.dataset.maxReached = maxReached ? 'true' : 'false';
            }
        };

        const fetchCart = () =>
            fetch('/cart.js')
                .then((response) => response.json())
                .then((cart) => {
                    buildCartQuantities(cart);
                    updateControls();
                })
                .catch((error) => console.warn('Failed to fetch cart data.', error));

        qtyInput.addEventListener('change', updateControls);
        decreaseBtn?.addEventListener('click', updateControls);
        increaseBtn?.addEventListener('click', updateControls);

        if (formEl && !formEl.dataset.maxGuardBound) {
            formEl.dataset.maxGuardBound = 'true';
            formEl.addEventListener('submit', (event) => {
                if (formEl.dataset.maxReached === 'true') {
                    event.preventDefault();
                    event.stopImmediatePropagation();
                }
            });
        }

        section.addEventListener('productHeroCustom:variant-change', updateControls);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
                if (event?.cartData) {
                    buildCartQuantities(event.cartData);
                    updateControls();
                } else {
                    fetchCart();
                }
            });
        }

        fetchCart();
    });
}

function initProductHeroCustomAccordions() {
    const sections = document.querySelectorAll('.productHeroCustom');

    sections.forEach((section) => {
        const items = section.querySelectorAll('.productHeroCustom_accordionItem');

        items.forEach((item) => {
            const trigger = item.querySelector('.productHeroCustom_accordionTrigger');
            const content = item.querySelector('.productHeroCustom_accordionContent');

            if (!trigger || !content) return;

            trigger.addEventListener('click', () => {
                const isActive = item.classList.contains('is-active');
                items.forEach((otherItem) => {
                    if (otherItem === item) return;
                    const otherContent = otherItem.querySelector('.productHeroCustom_accordionContent');
                    if (otherContent) {
                        otherItem.classList.remove('is-active');
                        otherContent.style.maxHeight = '0px';
                    }
                });
                if (isActive) {
                    item.classList.remove('is-active');
                    content.style.maxHeight = '0px';
                } else {
                    item.classList.add('is-active');
                    content.style.maxHeight = content.scrollHeight + 'px';
                }
            });
        });
    });
}

function initProductHeroCustomQuantity() {
    const sections = document.querySelectorAll('.productHeroCustom');

    sections.forEach((section) => {
        const qtyInput = section.querySelector('input[name="quantity"]');
        const decreaseBtn = section.querySelector('[data-qty-decrease]');
        const increaseBtn = section.querySelector('[data-qty-increase]');

        if (!qtyInput || !decreaseBtn || !increaseBtn) return;

        decreaseBtn.addEventListener('click', () => {
            const current = parseInt(qtyInput.value, 10) || 1;
            qtyInput.value = Math.max(1, current - 1);
            qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        });

        increaseBtn.addEventListener('click', () => {
            const current = parseInt(qtyInput.value, 10) || 1;
            qtyInput.value = current + 1;
            qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        });
    });
}

function initProductHeroCustomMimicSelector() {
    const sections = document.querySelectorAll('.productHeroCustom');

    sections.forEach((section) => {
        const rawUseMimicSelector = String(section.dataset.useMimicSelector || '').trim().toLowerCase();
        const useMimicSelector = ['true', '1', 'yes', 'on'].includes(rawUseMimicSelector);
        const mimicSelector = section.querySelector('[data-mimic-selector]');
        const mimicOptionsContainer = section.querySelector('[data-mimic-options-container]');
        const mimicOptionsScript = section.querySelector('[data-mimic-options]');
        const realVariantSelector = section.querySelector('[data-real-variant-selector]');
        const qtyInput = section.querySelector('input[name="quantity"]');
        const qtyDecreaseBtn = section.querySelector('[data-qty-decrease]');
        const qtyIncreaseBtn = section.querySelector('[data-qty-increase]');
        const priceEl = section.querySelector('[data-price]');
        const compareEl = section.querySelector('[data-compare-price]');
        const priceWrapper = section.querySelector('.productHeroCustom_price');
        const productForm = section.querySelector('product-form');
        const formEl = productForm?.querySelector('form');
        const variantIdInput = section.querySelector('[data-variant-id-input]');
        const basePriceCents = parseInt(section.dataset.basePrice || '0', 10);
        const discountPercentRaw = parseFloat(section.dataset.mimicDiscountPercent || '0');
        const discountPercent = Number.isFinite(discountPercentRaw)
            ? Math.max(0, Math.min(discountPercentRaw, 100))
            : 0;

        if (!useMimicSelector || !mimicSelector || !mimicOptionsContainer || !mimicOptionsScript || !qtyInput || !formEl || !variantIdInput || !basePriceCents) {
            return;
        }

        let mimicEntries = [];
        try {
            const parsed = JSON.parse(mimicOptionsScript.textContent || '[]');
            if (Array.isArray(parsed)) {
                mimicEntries = parsed;
            } else if (typeof parsed === 'string') {
                mimicEntries = parsed
                    .split(/\n|•|,/)
                    .map((item) => item.trim())
                    .filter(Boolean);
            } else {
                mimicEntries = [];
            }
        } catch (error) {
            console.warn('Invalid mimic options JSON.', error);
            return;
        }

        const parsedOptions = mimicEntries
            .map(parseMimicOption)
            .filter(Boolean);

        if (!parsedOptions.length) {
            return;
        }

        section.classList.add('productHeroCustom--mimic-active');
        realVariantSelector?.classList.add('hidden');
        mimicSelector.classList.remove('hidden');

        let selectedOption = parsedOptions[0];

        const optionButtons = parsedOptions.map((option, index) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'productHeroCustom_variantOption';
            button.dataset.mimicLabel = option.label;
            button.dataset.mimicMultiplier = String(option.multiplier);
            button.setAttribute('aria-pressed', index === 0 ? 'true' : 'false');

            const label = document.createElement('span');
            label.textContent = option.label;
            button.appendChild(label);

            button.addEventListener('click', () => {
                selectedOption = option;
                updateSelection();
            });

            mimicOptionsContainer.appendChild(button);
            return button;
        });

        const updateSelection = () => {
            optionButtons.forEach((button) => {
                const isSelected = button.dataset.mimicLabel === selectedOption.label
                    && Number(button.dataset.mimicMultiplier) === selectedOption.multiplier;
                button.classList.toggle('selected-variant', isSelected);
                button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
            });

            lockQuantityToMultiplier(qtyInput, qtyDecreaseBtn, qtyIncreaseBtn, selectedOption.multiplier);

            if (priceEl) {
                const subtotal = basePriceCents * selectedOption.multiplier;
                const shouldApplyDiscount = selectedOption.multiplier > 1;
                const discountedCents = subtotal * (1 - discountPercent / 100);
                const finalPriceCents = shouldApplyDiscount
                    ? Math.round(discountedCents / 10) * 10
                    : subtotal;
                priceEl.textContent = formatMoney(finalPriceCents);
            }

            if (compareEl) {
                compareEl.style.display = 'none';
                compareEl.textContent = '';
            }

            priceWrapper?.classList.remove('has-compare-price');
        };

        formEl.addEventListener('submit', () => {
            lockQuantityToMultiplier(qtyInput, qtyDecreaseBtn, qtyIncreaseBtn, selectedOption.multiplier);
        });

        updateSelection();
    });
}

function parseMimicOption(entry) {
    if (typeof entry !== 'string') return null;

    const [rawLabel, rawMultiplier] = entry.split('|');
    const label = (rawLabel || '').trim();
    if (!label) return null;

    let multiplier = parseInt((rawMultiplier || '').trim(), 10);
    if (!Number.isFinite(multiplier) || multiplier < 1) {
        multiplier = 1;
    }

    return { label, multiplier };
}

function lockQuantityToMultiplier(qtyInput, decreaseBtn, increaseBtn, multiplier) {
    const safeMultiplier = Number.isFinite(multiplier) && multiplier > 0 ? multiplier : 1;

    qtyInput.value = String(safeMultiplier);
    qtyInput.min = String(safeMultiplier);
    qtyInput.setAttribute('readonly', 'readonly');

    if (decreaseBtn) decreaseBtn.setAttribute('disabled', 'disabled');
    if (increaseBtn) increaseBtn.setAttribute('disabled', 'disabled');

    qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
}

function formatMoney(cents) {
    const normalizedCents = Number.isFinite(cents) ? cents : 0;
    if (window.theme?.Currency?.formatMoney) {
        const themeMoneyFormat = window.theme?.shopSettings?.moneyFormat || window.Shopify?.money_format || '${{amount}}';
        return window.theme.Currency.formatMoney(normalizedCents, themeMoneyFormat);
    }

    const fallbackMoneyFormat = window.Shopify?.money_format || '${{amount}}';
    const value = (normalizedCents / 100).toFixed(2);
    return fallbackMoneyFormat
        .replace('{{amount}}', value)
        .replace('{{amount_no_decimals}}', value.replace('.00', ''));
}
